module.exports = "/static/assets/a86dc7e23b0b7d455cff4bdb4515ebf0.png";